export default (id = ':id') => `/fleet/${id}`;
